var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmericanExpress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 80,
    viewBox: "0 0 120 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 80,
    rx: 4,
    fill: "#0690FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_703_18)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    width: 80,
    height: 80,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 80V67.3237H110.349L105.38 61.8293L100.386 67.3237H68.5643V41.7163H58.2938L71.0333 12.8854H83.3194L87.7051 22.7624V12.8854H102.913L105.553 20.3283L108.211 12.8854H120V0H40V80H120ZM111.974 64.1176H120L109.384 52.8594L120 41.7291H112.102L105.546 48.8936L99.0525 41.7291H91.025L101.579 52.9234L91.025 64.1176H98.8291L105.418 56.8893L111.974 64.1176ZM113.852 52.8688L120 59.4094V46.3827L113.852 52.8688ZM78.0717 58.9363V55.4499H90.7048V50.3965H78.0717V46.9106H91.0245L91.025 41.7291H71.9626V64.1176H91.025L91.0245 58.9363H78.0717ZM113.955 38.4802H120V16.0917H110.597L105.575 30.0362L100.586 16.0917H91.0229V38.4802H97.0675V22.8083L102.825 38.4802H108.198L113.955 22.776V38.4802ZM84.1464 38.4802H91.0229L81.1405 16.0917H73.2723L63.389 38.4802H70.1056L71.961 34.0026H82.2594L84.1464 38.4802ZM80.1488 28.981H74.0715L77.1102 21.6568L80.1488 28.981Z",
    fill: "#0690FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_703_18"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    width: 80,
    height: 80,
    rx: 4,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanExpress);
export default __webpack_public_path__ + "static/media/american-express.000bcb7ac68fe7d8d4d34882147f557e.svg";
export { ForwardRef as ReactComponent };